import React from 'react';
import { EllipsisVertical, Bell, LogOut, Users } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Menu } from '@mantine/core';
import { peep_client } from '~/src/api/peep';

interface HeaderProps {
  pageName: string;
}

export default function Header({ pageName }: HeaderProps) {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await peep_client.users.signout();
      navigate('/signin');
    } catch (error) {
      console.error('Failed to sign out:', error);
    }
  };

  return (
    <div className={'Header'}>
      <div
        style={{
          display: 'flex',
          backgroundColor: 'var(--global-main-lighter-8)',
          marginBottom: '0',
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100vw',
        }}
      >
        <div
          style={{
            overflow: 'hidden',
            borderRadius: '1rem',
            marginLeft: '.5rem',
            marginTop: '.4rem',
            marginBottom: '.4rem',
            height: '2rem',
            width: '2rem',
            boxShadow: '0px 0px 6px 2px rgba(0 0 0 / 10%)',
          }}
        >
          <img
            style={{
              height: '2rem',
              width: '2rem',
              cursor: 'pointer',
            }}
            src="/assets/img/new_logo.svg"
            alt="Peep logo"
            onClick={() => {
              navigate('/feed');
            }}
          />
        </div>
        <span
          style={{
            fontFamily: 'Bree Serif',
            fontSize: '1.2rem',
            textAlign: 'center',
            color: 'var(--global-main-darker-3)',
          }}
        >
          {pageName}
        </span>
        <div style={{ display: 'flex', gap: '.5rem', alignItems: 'center' }}>
          <Bell style={{ cursor: 'pointer' }} />
          <Users
            size="2rem"
            style={{ padding: '.25rem', cursor: 'pointer' }}
            onClick={() => {
              navigate('/group-management');
            }}
          />

          <Menu shadow="md" width={200}>
            <Menu.Target>
              <EllipsisVertical style={{ marginRight: '.5rem', cursor: 'pointer' }} />
            </Menu.Target>
            <Menu.Dropdown>
              <Menu.Item onClick={handleLogout} leftSection={<LogOut size={16} />}>
                Sign Out
              </Menu.Item>
            </Menu.Dropdown>
          </Menu>
        </div>
      </div>
    </div>
  );
}
